/**
 * The way into the Zuprize Partner page: a fourth homepage circle after
 * Klær, Sko and Tilbehør, an item after Tilbehør in the desktop menu, and a
 * row after the categories in the phone menu. All point at the Partner page
 * (/butikker), which goes straight to the partner when there is only one.
 *
 * The label is a translation key ("Butikker"), so it can be changed in
 * Console. The homepage circle shows the client's Zuprize Partner badge
 * (a serif Z over PARTNER), cropped to its ring; the desktop menu shows a
 * shop-front icon drawn to match the category icons (CategoryMenu/icons).
 */
export const PARTNER_ENTRANCE = {
  routeName: 'PartnerPage',
  labelId: 'PartnerEntrance.label',
  badgeImage: '/static/images/partner/partner-badge.svg',
};
